<template>
	<div
		id="operationType-detail"
		:class="[!isWeb ? 'mobile-operationType-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToOperations()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Adicionar Tipo de Operação' : 'Editar Tipo de Operação' }}
			</h1>
		</div>
		<OperationTypeForm :isWeb="isWeb" />
	</div>
</template>

<script>
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import OperationTypeForm from '@/components/modules/Operation/OperationTypeDetail/OperationTypeForm/OperationTypeForm.vue';

export default {
	name: 'OperationTypeDetail',
	components: { SidebarArrow, OperationTypeForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToOperations() {
			this.$router.push({ path: '/dashboard/config/operationType' });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'OperationTypeDetail.scss';
</style>
